import { getSalesMonitorItems, selectSalesMonitor } from 'actions'
import CommonTable from 'components/common/commonTable'
import { IFieldStructure } from 'constants/valuesInterfaces/interfaces'
import { getSelectFilter, getValueMask } from 'lib/MaskValues'
import { getFiltersTable } from 'lib/Utils'
import { IGetSalesHeadersTableFilters } from 'models/Budget'
import { IGetSalesMonitorItemsParams } from 'models/SalesMonitor'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import _ from 'underscore'
import { SEARCH_VOUCHER_DETAIL } from 'utils/RoutePath'
import style from './SalesMonitorTableStyle.module.scss'
import {
	ISalesMonitorTableProps,
	ISalesMonitorTableState
} from './SalesMonitorTableType'

class SalesMonitorTable extends Component<
	ISalesMonitorTableProps,
	ISalesMonitorTableState
> {
	constructor(props: ISalesMonitorTableProps) {
		super(props)

		this.state = {
			filtersKey: {
				cliente: 'filtro_cliente',
				cod_comp: 'filtro_cod_comp',
				detalle: 'filtro_detalle',
				fecha: 'filtro_fecha',
				nro_comp: 'filtro_nro_comp',
				sucursal: 'filtro_sucursal',
				imp_total: 'filtro_total',
				cant_unidades: 'filtro_cant_unidades',
				zona: 'filtro_zona',
				transporte: 'filtro_transporte'
			},
			rowSelected: [],
			lastRowSelected: '',
			showError: false,
			filtersForm: props.formFilters,
			filtersTable: {},
			tableFiltersReset: false
		}
	}

	componentDidUpdate(prevProps: Readonly<ISalesMonitorTableProps>): void {
		const { salesMonitorList } = this.props

		if (
			salesMonitorList !== prevProps.salesMonitorList &&
			!_.isEmpty(salesMonitorList) &&
			salesMonitorList.Items
		) {
			const rowSelected: any = []

			salesMonitorList.Items.forEach((item: any) => {
				if (item.sel) {
					rowSelected.push(item.id)
				}
			})

			this.setState({ rowSelected, showError: false }) // Items Selected From DB
		}
	}

	getLabelColumn = (field: IFieldStructure) => {
		const fieldId = field.idCampo.trim()
		const { salesMonitorList } = this.props
		const { filtersKey } = this.state

		if (filtersKey[fieldId] && salesMonitorList) {
			return ''
		} else {
			return field.label ? field.label : ''
		}
	}

	/**
	 * to create columns in the table
	 * @returns columns
	 */
	getColumns = () => {
		const { fields, salesMonitorList } = this.props
		const { filtersKey } = this.state

		const rows = fields.map((field) => {
			const campoId = field.idCampo.trim()
			return {
				dataField: campoId,
				text: this.getLabelColumn(field),
				align: campoId === 'imp_total' ? 'right' : 'center',
				headerAlign: 'center',
				hidden: !field.visible,
				filter: getSelectFilter(
					field,
					salesMonitorList,
					filtersKey,
					this.props,
					style.inputFilter
				),
				formatter: (cell: string, row: any) =>
					this.renderFormat(field, cell, row)
			}
		})

		return rows
	}

	/**
	 * render mask value
	 * @param field
	 * @param value
	 * @param row
	 * @returns
	 */
	renderFormat = (field: IFieldStructure, value: any, row: any) => {
		const { idCampo } = field
		let result = value
		const { authUser } = this.props

		if (idCampo === 'nro_comp') {
			result = (
				<Link target="_blank" to={`${SEARCH_VOUCHER_DETAIL}/${row.id}/consult`}>
					{value}
				</Link>
			)
		} else if (field.mascara) {
			result = getValueMask(value, field.mascara, { authUser })
		}

		return result
	}

	/**
	 * to handle change table
	 */
	handleChangeTable = (type: any, pagination: any) => {
		const { idOperacion, formFilters } = this.props
		const { filtersTable } = this.state
		let formParams: IGetSalesMonitorItemsParams = {
			...formFilters,
			idOperacion
		}

		let tableParams: IGetSalesHeadersTableFilters = { ...filtersTable }

		if (type === 'pagination') {
			const pag = {
				page_number: pagination.page,
				page_size: pagination.sizePerPage
			}
			formParams = { ...formParams, ...pag }
		} else if (type === 'filter') {
			const filters =
				type === 'filter' ? getFiltersTable(pagination.filters) : {}
			tableParams = { ...filters }
		}

		this.setState({
			filtersForm: { ...formParams },
			filtersTable: { ...tableParams }
		}) // Save Pagination or filters

		this.props.getSalesMonitorItems({ ...formParams, ...tableParams })
	}

	/**
	 * to get all select row options
	 */
	getSelectRowOptions = () => {
		const { rowSelected } = this.state

		return {
			mode: 'checkbox',
			selectColumnPosition: 'right',
			selected: rowSelected,
			headerColumnStyle: {
				textAlign: 'center',
				paddingRight: '8px !important'
			},
			style: (row: any) => {
				const backgroundColor = row.error ? '#f8d7da' : '#FFF'
				const marginBottom = 120
				return { backgroundColor, marginBottom }
			},
			onSelect: this.handleOnSelectCheck,
			onSelectAll: this.handleOnSelectAll
		}
	}

	/**
	 * to validate click on check
	 * @param row
	 */
	handleOnSelectCheck = (row: any, isSelect: boolean) => {
		const { idOperacion } = this.props
		const { rowSelected } = this.state
		let lastRowSelected = ''

		if (isSelect) {
			rowSelected.push(row.id)
			lastRowSelected = row.id
		} else {
			const idxFind = rowSelected.indexOf(row.id)
			rowSelected.splice(idxFind, 1)
		}
		const values = {
			idOperacion,
			lista_movs: [{ id: row.id, sel: isSelect ? 1 : 0 }]
		}
		this.props.selectSalesMonitor({ ...values })

		this.setState({ rowSelected, lastRowSelected })
	}

	/**
	 * to render the actions of the inputs checks
	 *
	 */
	handleOnSelectAll = (isSelect: boolean, rows: any) => {
		const { idOperacion } = this.props
		const rowSelected: string[] = []
		const lista_movs = rows.map((row: any) => {
			if (isSelect) {
				rowSelected.push(row.id)
			}
			return {
				id: row.id,
				sel: isSelect ? 1 : 0
			}
		})

		this.props.selectSalesMonitor({ idOperacion, lista_movs })
		this.setState({ rowSelected, lastRowSelected: 'All' })
	}

	getItemsData = () => {
		const { salesMonitorList } = this.props
		if (_.isEmpty(salesMonitorList)) {
			return []
		} else {
			if (salesMonitorList.Items) {
				return salesMonitorList.Items
			} else {
				return []
			}
		}
	}

	render() {
		const { fields, salesMonitorList } = this.props
		const { tableFiltersReset } = this.state

		const budgetTableProps = {
			remote: true,
			columns: !_.isEmpty(fields) ? this.getColumns() : [],
			selectRow: this.getSelectRowOptions(),
			data: this.getItemsData(),
			paginationOptions: salesMonitorList
				? {
						pageStartIndex: 1,
						sizePerPage: salesMonitorList.page_size,
						page: salesMonitorList.page_number,
						totalSize: salesMonitorList.total_count
				  }
				: {},
			onTableChange: this.handleChangeTable
		}

		return (
			!_.isEmpty(fields) &&
			!tableFiltersReset && <CommonTable {...budgetTableProps} />
		)
	}
}

const mapStateToProps = ({ auth, salesMonitor }: any) => {
	const { salesMonitorList } = salesMonitor

	const { authUser } = auth

	return { authUser, salesMonitorList }
}

const mapDispatchToProps = {
	getSalesMonitorItems,
	selectSalesMonitor
}

export default connect(mapStateToProps, mapDispatchToProps)(SalesMonitorTable)
